const EnvionmentVariables = {};
switch (process.env.NODE_ENV) {
  case 'development':
    // EnvionmentVariables.Api = 'http://192.168.1.78:4010/{param}/v1.0' // 78
    // EnvionmentVariables.Protocol = 'http://192.168.1.78:4010/{param}/v1.0' // 78
    // EnvionmentVariables.BASE_ACTIVITY = 'http://192.168.1.78:4010/{param}/v1.0' // 78
    // EnvionmentVariables.IMAGE_HOST = 'http://192.168.1.78:4010/' // 78

    // EnvionmentVariables.Api = '/api'
    // EnvionmentVariables.Protocol = 'https://wg.xkejia.cn/{param}/v1.0' // 测试
    // EnvionmentVariables.BASE_ACTIVITY = 'https://wg.xkejia.cn/{param}/v1.0' // 测试
    // EnvionmentVariables.IMAGE_HOST = 'https://wg.xkejia.cn/' // 测试

    EnvionmentVariables.Protocol = 'https://xkapi.xiekang.net/{param}/v1.0' // 基卫1.0.3
    EnvionmentVariables.BASE_ACTIVITY = 'https://xkapi.xiekang.net/{param}/v1.0' // 基卫1.0.3
    EnvionmentVariables.IMAGE_HOST = 'https://xkapi.xiekang.net/' // 基卫1.0.3
    // EnvionmentVariables.Protocol = 'https://xgnginx.xiekang.net/{param}/v1.0' // 基卫1.0.3
    // EnvionmentVariables.BASE_ACTIVITY = 'https://xgnginx.xiekang.net/{param}/v1.0' // 基卫1.0.3
    // EnvionmentVariables.IMAGE_HOST = 'https://xgnginx.xiekang.net/' // 基卫1.0.3
    break
  case 'production':
    // EnvionmentVariables.Api = 'http://192.168.1.78:4010/{param}/v1.0' // 78
    // EnvionmentVariables.Protocol = 'http://192.168.1.78:4010/{param}/v1.0' // 78
    // EnvionmentVariables.BASE_ACTIVITY = 'http://192.168.1.78:4010/{param}/v1.0' // 78
    // EnvionmentVariables.IMAGE_HOST = 'http://192.168.1.78:4010/' // 78

    EnvionmentVariables.Api = 'https://xkapi.xiekang.net/{param}/v1.0'// 正式
    EnvionmentVariables.Protocol = 'https://xkapi.xiekang.net/{param}/v1.0' // 正式
    EnvionmentVariables.BASE_ACTIVITY = 'https://xkapi.xiekang.net/{param}/v1.0' // 正式
    EnvionmentVariables.IMAGE_HOST = 'https://xkjcapi.xiekang.net/' // 正式

    // EnvionmentVariables.Api = 'https://xgnginx.xiekang.net/{param}/v1.0'// 城南
    // EnvionmentVariables.Protocol = 'https://xgnginx.xiekang.net/{param}/v1.0' // 城南
    // EnvionmentVariables.BASE_ACTIVITY = 'https://xgnginx.xiekang.net/{param}/v1.0' // 城南
    // EnvionmentVariables.IMAGE_HOST = 'https://xgnginx.xiekang.net/' // 城南

    // EnvionmentVariables.Api = 'https://wg.xkejia.cn/{param}/v1.0'// 基卫外网测试
    // EnvionmentVariables.Protocol = 'https://wg.xkejia.cn/{param}/v1.0'// 基卫外网测试
    // EnvionmentVariables.BASE_ACTIVITY = 'https://wg.xkejia.cn/{param}/v1.0'// 基卫外网测试
    // EnvionmentVariables.IMAGE_HOST = 'https://wg.xkejia.cn/'// 基卫外网测试
    break
}
export default EnvionmentVariables
